// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".G99dl{font-size:16px;font-weight:bold;text-decoration:underline;color:#1c8b1c}", "",{"version":3,"sources":["webpack://./src/common/components/GamePage/AttemptsCount/AttemptsCount.scss"],"names":[],"mappings":"AAAA,OACE,cAAA,CACA,gBAAA,CACA,yBAAA,CACA,aAAA","sourcesContent":[".wrap {\n  font-size: 16px;\n  font-weight: bold;\n  text-decoration: underline;\n  color: #1c8b1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "G99dl"
};
export default ___CSS_LOADER_EXPORT___;
